import { render, staticRenderFns } from "./SvgLink.vue?vue&type=template&id=f04fa0ce"
import script from "./SvgLink.vue?vue&type=script&lang=js"
export * from "./SvgLink.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports